// extracted by mini-css-extract-plugin
export default {"croppedImageContainer":"QueryImage_croppedImageContainer__dY6Wa","croppedImage":"QueryImage_croppedImage__emtmW","fullImage":"QueryImage_fullImage__nGGEM"};